type nEvent = Event & { target: HTMLElement, currentTarget: HTMLElement };
(function () {
    let header = {
        desktopWidth: 992,
        init: () => {
            header.control()
        },
        control: () => {
            if (window.innerWidth >= header.desktopWidth) return; // run only on tablet and smaller

            let nav = document.querySelector('.header .navbarSupportedContent');
            nav.addEventListener('customEventHeaderOpened', (e: nEvent) => {
                header.handleHeight('opened', e);
            })
            nav.addEventListener('customEventHeaderCollapsed', (e: nEvent) => {
                header.handleHeight('collapsed', e);
            })
        },
        handleHeight(state: 'opened' | 'collapsed', e: nEvent) {
            if (state === 'opened') {
                document.body.classList.add('lock-screen');
                document.body.classList.add('header-navbar-height-corrected');
                header.setMaxHeight(e.currentTarget);
            } else {
                header.clearHeight();
            }
        },
        setMaxHeight(nav: HTMLElement) {
            let ulList: HTMLElement = nav.parentElement.querySelector('.navbarSupportedContent > .rlist--inline');
            ulList.style.maxHeight = `${window.outerHeight - ulList.getBoundingClientRect().top}px`
        },
        clearHeight() {
            document.body.classList.remove('lock-screen');
            document.body.classList.remove('header-navbar-height-corrected');
        },

    };

    UX.hopeHeader = header;
})();
